/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TIsNewbuildingFavoritesRequest,
  TIsNewbuildingFavoritesModel,
  IMappers,
  TIsNewbuildingFavoritesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IIsNewbuildingFavoritesResponse } from '../../entities/newbuilding_favorites/IsNewbuildingFavoritesResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createIsNewbuildingFavoritesModel(
  parameters: TIsNewbuildingFavoritesRequest,
): TIsNewbuildingFavoritesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/is-newbuilding-favorites/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IIsNewbuildingFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TIsNewbuildingFavoritesRequest;
}

export async function fetchIsNewbuildingFavorites<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IIsNewbuildingFavoritesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TIsNewbuildingFavoritesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createIsNewbuildingFavoritesModel(parameters),
    config,
  )) as FetchResponse<TIsNewbuildingFavoritesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsNewbuildingFavoritesResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TIsNewbuildingFavoritesResponse>;
}
